<template>
  <div class="row">
    <p class="text-left">Campaigns available via mass launch are listed below. When you opt in to a campaign, it can be launched by administrator on your behalf.</p>
    <snappy-table
      ref="table"
      :endpoint="'vessels/' + vesselId + '/mass-launch'"
      :columns="['name', 'actions']"
      :headings="['Name', 'Actions']"
      :templated-slot-names="['actions']"
      :search-order-by="'id'"
      record-type="MassLaunchType"
    >
      <template #actions="{ row }">
        <div style="width:100px;">
          <button
            type="button"
            class="action-button btn"
            :class="row.is_enabled ? 'btn-danger' : 'btn-success'"
            :title="row.is_enabled ? 'Disable' : 'Enable'"
            v-tooltip="row.is_enabled ? 'Disable' : 'Enable'"
            @click="onToggleButtonClick($event, row)"
            :disabled="isSpinning(row.id)">
            {{ row.is_enabled ? 'Disable' : 'Enable' }}
            <i v-if="isSpinning(row.id)" class="fas fa-fw fa-spinner fa-spin"></i>
          </button>
        </div>
      </template>
    </snappy-table>
  </div>
</template>

<script>
import SnappyTable from '../components/SnappyTable';
import swal from "sweetalert2";

export default {
  name: 'account-mass-launch-page',
  components: {SnappyTable},
  props: {
    vesselId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      spinningBtnIds: [],
    }
  },
  methods: {
    isSpinning(value) {
      return this.spinningBtnIds.includes(value);
    },
    onToggleButtonClick(event, mass_launch_type) {
      let self = this;
      let action = mass_launch_type.is_enabled ? 'disableMassLaunchType' : 'enableMassLaunchType';

      this.addSpinner(mass_launch_type.id);

      axios.post('/api/?entity=mass-launch&action=' + action + '&massLaunchId=' + mass_launch_type.id)
        .then((result) => {
          if (result.status === 204) {
            mass_launch_type.is_enabled = !mass_launch_type.is_enabled;

            this.removeSpinner(mass_launch_type.id);
          } else {
            swal.fire({
              title: 'UhOh!',
              text: 'Something went wrong.',
              type: 'error',
              confirmButtonText: 'Ok',
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-lg btn-primary',
            }).then(function () {
              self.refresh();
            });

            this.removeSpinner(mass_launch_type.id);
          }
        });
    },
    addSpinner(value) {
      this.spinningBtnIds.push(value);
    },
    removeSpinner(value) {
      this.spinningBtnIds.splice(this.spinningBtnIds.indexOf(value), 1);
    },
    refresh() {
      this.$refs.table.refresh();
    },
  },
}
</script>
